import { Suspense, lazy } from "react";
import { Navigate, type RouteObject } from "react-router";

import { DASHBOARD_BILLING_LOADER } from "@application/loaders/dashboard_billing_loader";

import { DASHBOARD_BILLING_LINK } from "@application/navigation/dashboard_billing_link";

import { Loader } from "@styled/loader";

const DashboardBilling = lazy(() =>
  import("./billing").then((m) => ({ default: m.DashboardBilling })),
);
const BillingOverview = lazy(() =>
  import("./billing_overview/index").then((m) => ({
    default: m.BillingOverview,
  })),
);
const BillingDetail = lazy(() =>
  import("./billing_verification").then((m) => ({
    default: m.BillingVerification,
  })),
);

export const DASHBOARD_BILLING_ROUTE = {
  path: "billing",
  element: (
    <Suspense fallback={<Loader />}>
      <DashboardBilling />
    </Suspense>
  ),
  loader: DASHBOARD_BILLING_LOADER,
  handle: DASHBOARD_BILLING_LINK,
  children: [
    { index: true, element: <Navigate to="overview" replace /> },
    {
      path: "overview",
      element: (
        <Suspense fallback={<Loader />}>
          <BillingOverview />
        </Suspense>
      ),
      handle: { name: "Overview", to: "/dashboard/billing/overview" },
    },
    {
      path: "detail",
      element: (
        <Suspense fallback={<Loader />}>
          <BillingDetail />
        </Suspense>
      ),
      handle: { name: "By Project", to: "/dashboard/billing/detail" },
    },
  ],
} satisfies RouteObject;
